import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=230955a8"
import script from "./AddAttribute.vue?vue&type=script&lang=js"
export * from "./AddAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports